import styled, { css } from 'styled-components'

import { GridContainer } from 'shared/style/grid'

export const MapFilter = styled(GridContainer)`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 520px;
  padding-top: 16px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md - 1}px) {
    min-width: 100vw;
  }

  > div {
    flex-grow: 1;

    &:last-of-type {
      width: fit-content;
      max-width: 100%;
    }
  }

  button {
    width: 40px;
  }
`

const baseText = css`
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  color: #303032;
  margin-bottom: 1rem;
`

export const PlaceAutocomplete = styled.div`
  width: 100%;
  background-color: #fff;
  border-radius: 4px;
`

export const CardContent = styled.div`
  display: flex;
  padding-left: 6px;
  gap: 16px;
`

export const Title = styled.h2`
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px;
  color: #303032;
`

export const Grupoalvo = styled.h3`
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  color: #006bff;
`

export const Address = styled.address`
  ${baseText}
`

export const Content = styled.div``

export const ImageContainer = styled.div`
  display: flex;
`

export const WorkingSchedule = styled.div`
  ${baseText}
`

export const InfoLabel = styled.h3`
  ${baseText}
  font-weight: 600;
  margin-bottom: 0;
`

export const InfoText = styled.p`
  ${baseText}
`
